import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { JsonRequest } from '../../../../model/jsonRequest.model';
import { properties } from '../../../../../environments/properties';
import { CoreApiService } from '../../../../core/service/core-api-service';
import { AppService } from '../../../../core/service/app.service';
import { StoreModel } from '../../../../model/store.model';
import { STORE_STATUS_CONFIG, StoreStatusConfig, StoreStatusEnum } from '../../../../model/store-status.model';

@Component({
  selector: 'app-list-store',
  standalone: true,
  imports: [
    ButtonModule,
    TableModule,
    TooltipModule,
    TagModule,
    CommonModule,
    RouterLink,
    DialogModule,
    InputTextModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    ToastModule,
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './list-store.component.html',
  styleUrl: './list-store.component.css',
})
export class ListStoreComponent implements OnInit {
  ltsStore: StoreModel[] = [];
  titulo: string = 'Negocios';
  loading: boolean = false;
  readonly STORE_STATUS_CONFIG = STORE_STATUS_CONFIG;

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
  ) {}

  ngOnInit(): void {
    this.getListStore();
  }

  getListStore(): void {
    this.loading = true;
    this.apiService.consumirWSGet(
      properties.serviceGetAllStore,
      null,
      (data) => {
        this.ltsStore = data.data;
        this.loading = false;
      },
    );
  }

  getStatusConfig(statusId: number): StoreStatusConfig {
    return STORE_STATUS_CONFIG[statusId as StoreStatusEnum] || STORE_STATUS_CONFIG[StoreStatusEnum.PENDING];
  }
}
